<template>
    <div class="main">
        <a-card>
            <!-- <h1>项目名</h1> -->
            <a-button type="primary" @click="addNew" icon="plus">{{ btnName }}</a-button>
            <div class="infoBox">
                <div class="floor">
                    <div class="floorItem" v-for="(item, index) in floorList" :key="index">
                        <div v-if="item.isShow" class="name" @click="floorChange(item.id, index)" :class="activeIsShow1 && floorIndex == index ? 'nameAcitve' : ''">{{ item.name }}</div>
                        <a-icon v-if="!activeIsShow1" type="form" class="tableIcon" @click="editInfo(item, 1)"/>
                        <div v-if="!activeIsShow1" class="tableImg" @click="deleteInfo(item, 1)"></div>
                    </div>
                </div>
                <div class="floor">
                    <div class="floorItem" v-for="(item, index) in layerList" :key="index">
                        <a-icon v-if="item.isShow" type="right" class="rightIcon"/>
                        <div v-if="item.isShow" class="name" @click="layerChange(item.id, index)" :class="activeIsShow2 && layerIndex == index ? 'nameAcitve' : ''">{{ item.name }}</div>
                        <a-icon v-if="!activeIsShow2" type="form" class="tableIcon" @click="editInfo(item, 2)"/>
                        <div v-if="!activeIsShow2" class="tableImg" @click="deleteInfo(item, 2)"></div>
                    </div>
                </div>
                <div class="floor">
                    <div class="floorItem" v-for="(item, index) in roomList" :key="index">
                        <a-icon v-if="item.isShow" type="right" class="rightIcon"/>
                        <div v-if="item.isShow" class="name" @click="roomChange(item.id, index)" :class="activeIsShow3 && roomIndex == index ? 'nameAcitve' : ''">{{ item.name }}</div>
                        <a-icon v-if="!activeIsShow3" type="form" class="tableIcon" @click="editInfo(item, 3)"/>
                        <div v-if="!activeIsShow3" class="tableImg" @click="deleteInfo(item, 3)"></div>
                    </div>
                </div>
                <div class="floor">
                    <div class="floorItem" v-for="(item, index) in bedList" :key="index">
                        <a-icon type="right" class="rightIcon"/>
                        <div class="name">{{ item.name }}</div>
                        <a-icon type="form" class="tableIcon" @click="editInfo(item, 4)"/>
                        <div class="tableImg" @click="deleteInfo(item, 4)"></div>
                    </div>
                </div>
                <!-- <div class="infoBtn">
                    <a-icon type="form" class="tableIcon"/>
                    <div class="tableImg"></div>
                </div> -->
            </div>
        </a-card>
        <!-- 新增楼、层、房间、床位 -->
        <a-modal
            :title="btnName"
            :visible="addNewPopup"
            :maskClosable="false"
            :width="350"
            @cancel="addNewOff"
            :footer="null"
        >
            <p class="radarTitle">最多支持20位字符，不支持特殊符号</p>
            <a-input onkeyup="value=value.replace(/[^\a-\z\A-\Z0-9\u4E00-\u9FA5\ ]/g,'')" v-model="inputVal" :placeholder="placeholder" :maxLength="20" class="floorName" />
            <div class="radarBtn">
                <a-button style="margin-right: 10px;" @click="addNewOff">取消</a-button>
                <a-button type="primary" @click="addNewOk" :loading="loading">创建</a-button>
            </div>
        </a-modal>
        <!-- 修改楼、层、房间、床位 -->
        <a-modal
            :title="editBtnName"
            :visible="editNewPopup"
            :maskClosable="false"
            :width="350"
            @cancel="editNewOff"
            :footer="null"
        >
            <p class="radarTitle">最多支持20位字符，不支持特殊符号</p>
            <a-input onkeyup="value=value.replace(/[^\a-\z\A-\Z0-9\u4E00-\u9FA5\ ]/g,'')" v-model="detailsName.name" :placeholder="placeholder" :maxLength="20" class="floorName" />
            <div class="radarBtn">
                <a-button style="margin-right: 10px;" @click="editNewOff">取消</a-button>
                <a-button type="primary" @click="editNewOk" :loading="loading">确定</a-button>
            </div>
        </a-modal>
        <!-- 删除弹窗 -->
        <a-modal
            title=""
            :width="200"
            :visible="delPopup"
            :footer="null"
            :closable="false"
        >
            <p class="delTips"><a-icon type="exclamation-circle" />你确定要删除吗？</p>
            <div class="delBtn">
                <a-button style="margin-right: 10px;" @click="delCancel">取消</a-button>
                <a-button type="primary" @click="delOk" :loading="loading">确定</a-button>
            </div>
        </a-modal>
    </div>
</template>

<script>
export default {
    data(){
        return {
            addNewPopup: false, // 创建新楼、层、房间、床位弹窗状态
            inputVal: '', // 创建新楼、层、房间、床位名称
            editNewPopup: false, // 修改、层、房间、床位弹窗状态
            delPopup: false, // 删除、层、房间、床位弹窗状态
            loading: false,
            pageNum: 1,
            pageSize: 10000,
            floorList: [], // 楼信息数据
            layerList: [], // 层信息数据
            roomList: [], // 房间信息数据
            bedList: [], // 床位信息数据

            activeIsShow1: false, // 当前选中楼的状态
            floorValue: '', // 当前选中楼的值
            floorIndex: '', // 当前选中楼的下标

            activeIsShow2: false, // 当前选中层的状态
            layerValue: '', // 当前选中层的值
            layerIndex: '', // 当前选中层的下标

            activeIsShow3: false, // 当前选中房间的状态
            roomValue: '', // 当前选中房间的值
            roomIndex: '', // 当前选中房间的下标

            btnName: '创建新楼', // 新建按钮文字描述
            editBtnName: '修改楼名', // 新建按钮文字描述
            placeholder: '请输入楼名', // 新建输入框提示语
            typeNum: '', // 标记

            typeId: '', // 详情id
            detailsName: {}, // 详情name
            buildingId: '', // 楼id
            floorId: '', // 层id
            roomId: '', // 房间id
        }
    },
    mounted(){
        this.getFloorData();
    },
    methods: {
        // 获取楼信息
        getFloorData(){
            let param = {
                pageNum: this.pageNum,
                pageSize: this.pageSize
            }
            this.$get('/api/building/showPage', param, res => {
                if(res.code == 0){
                    if(res.data.records){
                        for(let i = 0;i < res.data.records.length;i++){
                            res.data.records[i].isShow = true;
                        }
                        this.floorList = res.data.records;
                    }else{
                        this.floorList =[];
                    }
                }else{
                    this.$message.error(res.msg)
                    this.floorList =[];
                }
            }, err => {
                console.log(err);
                // this.$message.error('服务端发生异常')
            })
        },
        // 获取层信息
        getLayerData(buildingId){
            let param = {
                pageNum: this.pageNum,
                pageSize: this.pageSize,
                buildingId: buildingId
            }
            this.$get('/api/floor/showPage', param, res => {
                if(res.code == 0){
                    if(res.data.records){
                        for(let i = 0;i < res.data.records.length;i++){
                            res.data.records[i].isShow = true;
                        }
                        this.layerList = res.data.records;
                    }else{
                        this.layerList =[];
                    }
                }else{
                    this.$message.error(res.msg)
                    this.layerList =[];
                }
            }, err => {
                console.log(err);
                // this.$message.error('服务端发生异常')
            })
        },
        // 获取房间信息
        getRoomData(floorId){
            let param = {
                pageNum: this.pageNum,
                pageSize: this.pageSize,
                floorId: floorId
            }
            this.$get('/api/room/showPage', param, res => {
                if(res.code == 0){
                    if(res.data.records){
                        for(let i = 0;i < res.data.records.length;i++){
                            res.data.records[i].isShow = true;
                        }
                        this.roomList = res.data.records;
                    }else{
                        this.roomList =[];
                    }
                }else{
                    this.$message.error(res.msg)
                    this.roomList =[];
                }
            }, err => {
                console.log(err);
                // this.$message.error('服务端发生异常')
            })
        },
         // 获取床位信息
        getBedData(roomId){
            let param = {
                pageNum: this.pageNum,
                pageSize: this.pageSize,
                roomId: roomId
            }
            this.$get('/api/bed/showPage', param, res => {
                if(res.code == 0){
                    if(res.data.records){
                        this.bedList = res.data.records;
                    }else{
                        this.bedList =[];
                    }
                }else{
                    this.bedList =[];
                    this.$message.error(res.msg)
                }
            }, err => {
                console.log(err);
                // this.$message.error('服务端发生异常')
            })
        },
        // 创建新楼、层、房间、床位按钮
        addNew(){
            this.addNewPopup = true;
            this.inputVal = '';
            if(this.btnName == '创建新楼'){
                this.placeholder = '请输入楼名';
            }else if(this.btnName == '创建新层'){
                this.placeholder = '请输入层名';
            }else if(this.btnName == '创建新房间'){
                this.placeholder = '请输入房间名';
            }else if(this.btnName == '创建新床位'){
                this.placeholder = '请输入床位名';
            }
        },
        // 创建新楼、层、房间、床位弹窗取消按钮
        addNewOff(){
            this.addNewPopup = false;
        },
        // 创建新楼、层、房间、床位弹窗确定按钮
        addNewOk(){
            console.log(this.btnName);
            if(this.btnName == '创建新楼'){
                this.submitFloor();
            }else if(this.btnName == '创建新层'){
                this.submitLayer();
            }else if(this.btnName == '创建新房间'){
                this.submitRoom();
            }else if(this.btnName == '创建新床位'){
                this.submitBed();
            }
        },
        // 新增楼
        submitFloor(){
            this.loading = true;
            this.$post('/api/building', { name: this.inputVal }, res => {
                if(res.code == 0){
                    this.$message.success('创建成功');
                    this.addNewPopup = false;
                    this.getFloorData();
                }else{
                    this.$message.error(res.msg)
                }
                this.loading = false;
            }, err => {
                this.loading = false;
                console.log(err);
                // this.$message.error('服务端发生异常')
            })
        },
        // 新增层
        submitLayer(){
            let param = {
                buildingId: this.buildingId,
                name: this.inputVal
            }
            this.loading = true;
            this.$post('/api/floor', param, res => {
                if(res.code == 0){
                    this.$message.success('创建成功');
                    this.addNewPopup = false;
                    this.getLayerData(this.buildingId);
                }else{
                    this.$message.error(res.msg)
                }
                this.loading = false;
            }, err => {
                this.loading = false;
                console.log(err);
                // this.$message.error('服务端发生异常')
            })
        },
        // 新增房间
        submitRoom(){
            let param = {
                buildingId: this.buildingId,
                floorId: this.floorId,
                name: this.inputVal
            }
            this.loading = true;
            this.$post('/api/room', param, res => {
                if(res.code == 0){
                    this.$message.success('创建成功');
                    this.addNewPopup = false;
                    this.getRoomData(this.floorId);
                }else{
                    this.$message.error(res.msg)
                }
                this.loading = false;
            }, err => {
                this.loading = false;
                console.log(err);
                // this.$message.error('服务端发生异常')
            })
        },
        // 新增床位
        submitBed(){
            let param = {
                buildingId: this.buildingId,
                floorId: this.floorId,
                roomId: this.roomId,
                name: this.inputVal
            }
            this.loading = true;
            this.$post('/api/bed', param, res => {
                if(res.code == 0){
                    this.$message.success('创建成功');
                    this.addNewPopup = false;
                    this.getBedData(this.roomId);
                }else{
                    this.$message.error(res.msg)
                }
                this.loading = false;
            }, err => {
                this.loading = false;
                console.log(err);
                // this.$message.error('服务端发生异常')
            })
        },
        // 修改按钮
        editInfo(item, type){
            console.log(item);
            this.editNewPopup = true;
            this.typeNum = type;
            if(type == 1){
                this.placeholder = '请输入楼名';
                this.editBtnName = '修改楼名';
                this.typeId = item.id;
                this.getFloorDetail()
            }else if(type == 2){
                this.placeholder = '请输入层名';
                this.editBtnName = '修改层名';
                this.typeId = item.id;
                this.getLayerDetail()
            }else if(type == 3){
                this.placeholder = '请输入房间名';
                this.editBtnName = '修改房间名';
                this.typeId = item.id;
                this.getRoomDetail()
            }else if(type == 4){
                this.placeholder = '请输入床位名';
                this.editBtnName = '修改床位名';
                this.typeId = item.id;
                this.getBedDetail()
            }
        },
        // 确定修改
        editNewOk(){
            if(this.typeNum == 1){
                this.editFloor()
            }else if(this.typeNum == 2){
                this.editLayer()
            }else if(this.typeNum == 3){
                this.editRoom()
            }else if(this.typeNum == 4){
                this.editBed()
            }
        },
        // 修改楼
        editFloor(){
            let param = {
                id: this.detailsName.id,
                name: this.detailsName.name
            }
            this.loading = true;
            this.$put('/api/building', param, res => {
                if(res.code == 0){
                    this.$message.success('修改成功');
                    this.editNewPopup = false;
                    this.getFloorData();
                }else{
                    this.$message.error(res.msg)
                }
                this.loading = false;
            }, err => {
                console.log(err);
                this.loading = false;
                this.$message.error('服务端发生异常')
            })
        },
        // 修改层
        editLayer(){
            let param = {
                id: this.detailsName.id,
                name: this.detailsName.name,
                buildingId: this.buildingId
            }
            this.loading = true;
            this.$put('/api/floor', param, res => {
                if(res.code == 0){
                    this.$message.success('修改成功');
                    this.editNewPopup = false;
                    this.getLayerData(this.buildingId);
                }else{
                    this.$message.error(res.msg)
                }
                this.loading = false;
            }, err => {
                this.loading = false;
                console.log(err);
                this.$message.error('服务端发生异常')
            })
        },
        // 修改房间
        editRoom(){
            let param = {
                id: this.detailsName.id,
                name: this.detailsName.name,
                buildingId: this.buildingId,
                floorId: this.floorId,
            }
            this.loading = true;
            this.$put('/api/room', param, res => {
                if(res.code == 0){
                    this.$message.success('修改成功');
                    this.editNewPopup = false;
                    this.getRoomData(this.floorId);
                }else{
                    this.$message.error(res.msg)
                }
                this.loading = false;
            }, err => {
                this.loading = false;
                console.log(err);
                this.$message.error('服务端发生异常')
            })
        },
        // 修改床位
        editBed(){
            let param = {
                id: this.detailsName.id,
                name: this.detailsName.name,
                buildingId: this.buildingId,
                roomId: this.roomId,
            }
            this.loading = true;
            this.$put('/api/bed', param, res => {
                if(res.code == 0){
                    this.$message.success('修改成功');
                    this.editNewPopup = false;
                    this.getBedData(this.roomId);
                }else{
                    this.$message.error(res.msg)
                }
                this.loading = false;
            }, err => {
                this.loading = false;
                console.log(err);
                this.$message.error('服务端发生异常')
            })
        },
        // 修改取消
        editNewOff(){
            this.editNewPopup = false;
        },
        // 获取楼详情
        getFloorDetail(){
            this.$get('/api/building/' + this.typeId, {}, res => {
                if(res.code == 0){
                    if(res.data){
                        this.detailsName = res.data;
                    }
                }else{
                    this.$message.error(res.msg)
                }
            }, err => {
                console.log(err);
                this.$message.error('服务端发生异常')
            })
        },
        // 获取层详情
        getLayerDetail(){
            this.$get('/api/floor/' + this.typeId, {}, res => {
                if(res.code == 0){
                    if(res.data){
                        this.detailsName = res.data;
                    }
                }else{
                    this.$message.error(res.msg)
                }
            }, err => {
                console.log(err);
                this.$message.error('服务端发生异常')
            })
        },
        // 获取房间详情
        getRoomDetail(){
            this.$get('/api/room/' + this.typeId, {}, res => {
                if(res.code == 0){
                    if(res.data){
                        this.detailsName = res.data;
                    }
                }else{
                    this.$message.error(res.msg)
                }
            }, err => {
                console.log(err);
                this.$message.error('服务端发生异常')
            })
        },
        // 获取床位详情
        getBedDetail(){
            this.$get('/api/bed/' + this.typeId, {}, res => {
                if(res.code == 0){
                    if(res.data){
                        this.detailsName = res.data;
                    }
                }else{
                    this.$message.error(res.msg)
                }
            }, err => {
                console.log(err);
                this.$message.error('服务端发生异常')
            })
        },
        // 删除按钮
        deleteInfo(item, type){
            this.delPopup = true;
            this.typeNum = type;
            if(type == 1){
                this.typeId = item.id;
            }else if(type == 2){
                this.typeId = item.id;
            }else if(type == 3){
                this.typeId = item.id;
            }else if(type == 4){
                this.typeId = item.id;
            }
        },
        // 确定删除
        delOk(){
            if(this.typeNum == 1){
                this.delFloor()
            }else if(this.typeNum == 2){
                this.delLayer()
            }else if(this.typeNum == 3){
                this.delRoom()
            }else if(this.typeNum == 4){
                this.delBed()
            }
        },
        // 取消删除
        delCancel(){
            this.delPopup = false;
        },
        // 删除楼
        delFloor(){
            this.loading = true;
            this.$delete('/api/building/' + this.typeId, {}, res => {
                if(res.code == 0){
                    this.$message.success('删除成功');
                    this.delPopup = false;
                    this.getFloorData();
                }else{
                    this.$message.error(res.msg)
                }
                this.loading = false;
            }, err => {
                console.log(err);
                this.loading = false;
                this.$message.error('服务端发生异常')
            })
        },
        // 删除层
        delLayer(){
            this.loading = true;
            this.$delete('/api/floor/' + this.typeId, {}, res => {
                if(res.code == 0){
                    this.$message.success('删除成功');
                    this.delPopup = false;
                    this.getLayerData(this.buildingId);
                }else{
                    this.$message.error(res.msg)
                }
                this.loading = false;
            }, err => {
                this.loading = false;
                console.log(err);
                this.$message.error('服务端发生异常')
            })
        },
        // 删除房间
        delRoom(){
            this.loading = true;
            this.$delete('/api/room/' + this.typeId, {}, res => {
                if(res.code == 0){
                    this.$message.success('删除成功');
                    this.delPopup = false;
                    this.getRoomData(this.floorId);
                }else{
                    this.$message.error(res.msg)
                }
                this.loading = false;
            }, err => {
                this.loading = false;
                console.log(err);
                this.$message.error('服务端发生异常')
            })
        },
        // 删除床位
        delBed(){
            this.loading = true;
            this.$delete('/api/bed/' + this.typeId, {}, res => {
                if(res.code == 0){
                    this.$message.success('删除成功');
                    this.delPopup = false;
                    this.getBedData(this.roomId);
                }else{
                    this.$message.error(res.msg)
                }
                this.loading = false;
            }, err => {
                this.loading = false;
                console.log(err);
                this.$message.error('服务端发生异常')
            })
        },
        // 监听楼选中状态
        floorChange(val, ind){
            if(!this.floorValue){
                this.activeIsShow1 = true;
                this.floorValue = val;
                this.floorIndex= ind;
                this.btnName = '创建新层';
                for(let i = 0;i < this.floorList.length;i++){
                    this.floorList[i].isShow = false;
                    if(val == this.floorList[i].id){
                        this.floorList[i].isShow = true;
                    }
                }
                this.getLayerData(val)
                this.buildingId = val;
            }else if(this.floorValue && this.floorValue != val){
                this.activeIsShow1 = true;
                this.floorValue = val;
                this.floorIndex= ind;
                this.btnName = '创建新层';
                for(let i = 0;i < this.floorList.length;i++){
                    this.floorList[i].isShow = false;
                    if(val == this.floorList[i].id){
                        this.floorList[i].isShow = true;
                    }
                }
                this.getLayerData(val);
                this.buildingId = val;
            }else if(val == this.floorValue){
                this.activeIsShow1 = false;
                this.floorValue = '';
                this.floorIndex = '';
                this.btnName = '创建新楼';
                for(let i = 0;i < this.floorList.length;i++){
                    this.floorList[i].isShow = true;
                }
                this.layerList = [];
                this.roomList = [];
                this.bedList = [];
                this.activeIsShow2 = false;
                this.layerIndex = '';
                this.layerValue = '';
                this.activeIsShow3 = false;
                this.roomIndex = '';
                this.roomValue = '';
            }else if(val == !this.floorValue){
                this.activeIsShow1 = true;
                this.floorValue = val;
                this.floorIndex= ind;
                this.btnName = '创建新层';
                for(let i = 0;i < this.floorList.length;i++){
                    this.floorList[i].isShow = false;
                    if(val == this.floorList[i].id){
                        this.floorList[i].isShow = true;
                    }
                }
                this.getLayerData(val);
                this.buildingId = val;
            }
        },
        // 监听层选中状态
        layerChange(val, ind){
            if(!this.layerValue){
                this.activeIsShow2 = true;
                this.layerValue = val;
                this.layerIndex= ind;
                this.btnName = '创建新房间';
                for(let i = 0;i < this.layerList.length;i++){
                    this.layerList[i].isShow = false;
                    if(val == this.layerList[i].id){
                        this.layerList[i].isShow = true;
                    }
                }
                this.getRoomData(val)
                this.floorId = val;
            }else if(this.layerValue && this.layerValue != val){
                this.activeIsShow2 = true;
                this.layerValue = val;
                this.layerIndex= ind;
                this.btnName = '创建新房间';
                for(let i = 0;i < this.layerList.length;i++){
                    this.layerList[i].isShow = false;
                    if(val == this.layerList[i].id){
                        this.layerList[i].isShow = true;
                    }
                }
                this.getRoomData(val);
                this.floorId = val;
            }else if(val == this.layerValue){
                this.activeIsShow2 = false;
                this.layerValue = '';
                this.layerIndex = '';
                this.btnName = '创建新层';
                for(let i = 0;i < this.layerList.length;i++){
                    this.layerList[i].isShow = true;
                }
                this.roomList = [];
                this.bedList = [];
                this.activeIsShow3 = false;
                this.roomIndex = '';
                this.roomValue = '';
            }else if(val == !this.layerValue){
                this.activeIsShow2 = true;
                this.layerValue = val;
                this.layerIndex= ind;
                this.btnName = '创建新房间';
                for(let i = 0;i < this.layerList.length;i++){
                    this.layerList[i].isShow = false;
                    if(val == this.layerList[i].id){
                        this.layerList[i].isShow = true;
                    }
                }
                this.getRoomData(val);
                this.floorId = val;
            }
        },
        // 监听房间选中状态
        roomChange(val, ind){
            if(!this.roomValue){
                this.activeIsShow3 = true;
                this.roomValue = val;
                this.roomIndex= ind;
                this.btnName = '创建新床位';
                for(let i = 0;i < this.roomList.length;i++){
                    this.roomList[i].isShow = false;
                    if(val == this.roomList[i].id){
                        this.roomList[i].isShow = true;
                    }
                }
                this.getBedData(val)
                this.roomId = val;
            }else if(this.roomValue && this.roomValue != val){
                this.activeIsShow3 = true;
                this.roomValue = val;
                this.roomIndex= ind;
                this.btnName = '创建新床位';
                for(let i = 0;i < this.roomList.length;i++){
                    this.roomList[i].isShow = false;
                    if(val == this.roomList[i].id){
                        this.roomList[i].isShow = true;
                    }
                }
                this.getBedData(val);
                this.roomId = val;
            }else if(val == this.roomValue){
                this.activeIsShow3 = false;
                this.roomValue = '';
                this.roomIndex = '';
                this.btnName = '创建新房间';
                for(let i = 0;i < this.roomList.length;i++){
                    this.roomList[i].isShow = true;
                }
                this.bedList = [];
            }else if(val == !this.roomValue){
                this.activeIsShow3 = true;
                this.roomValue = val;
                this.roomIndex= ind;
                this.btnName = '创建新床位';
                for(let i = 0;i < this.roomList.length;i++){
                    this.roomList[i].isShow = false;
                    if(val == this.roomList[i].id){
                        this.roomList[i].isShow = true;
                    }
                }
                this.getBedData(val);
                this.roomId = val;
            }
        },
    }
}
</script>

<style lang="scss" scoped>
    .main::v-deep{
        .ant-card{
            padding: 0;
            border-radius: 8px;
            background: #FFFFFF;
            box-shadow: 0px 3px 6px -2px rgba(0, 0, 0, 0.12);
            margin-top: 20px;
            h1{
                color: #262626;
                font-size: 18px;
                margin: 0;
            }
            .ant-btn{
                margin: 10px 0;
            }
            .infoBox{
                display: flex;
                .floor{
                    .floorItem{
                        display: flex;
                        align-items: center;
                        .rightIcon{
                            margin: 0 12px;
                            font-size: 14px;
                            color: #b0b0b0;
                            padding-bottom: 10px;
                        }
                        .name{
                            margin-bottom: 10px;
                            padding: 0 12px;
                            height: 32px;
                            background: #E6F7FF;
                            border-radius: 2px;
                            font-size: 14px;
                            color: #1890FF;
                            text-align: center;
                            line-height: 32px;
                            border: 1px solid #E6F7FF;
                        }
                        .name:hover{
                            background: #BAE7FF;
                            color: #1890FF;
                            border: 1px solid #1890ff;
                        }
                        .nameAcitve{
                            background: #BAE7FF;
                            color: #1890FF;
                            border: 1px solid #1890ff;
                        }
                    }
                }
                .tableIcon{
                    color: #1890FF;
                    font-size: 20px;
                    margin: 0 20px;
                    cursor: pointer;
                    padding-bottom: 10px;
                }
                .tableIcon:hover{
                    color: #0072DB;
                }
                .tableImg{
                    width: 18px;
                    height: 20px;
                    margin-bottom: 10px;
                    cursor: pointer;
                    background: url('../../assets/icon_trashCan_nor.png') no-repeat center;
                }
                .tableImg:hover{
                    background: url('../../assets/icon_trashCan_ove.png') no-repeat center;
                }
            }
        }
    }
    .radarTitle{
        color: #595959;
        font-size: 14px;
    }
    .floorName{
        width: 240px;
    }
    .radarBtn{
        text-align: right;
        margin-top: 30px;
        .ant-btn{
            border-radius: 2px;
        }
    }
    .delTips{
        .anticon{
            color: #FAAD14;
            margin-right: 10px;
        }
    }
    .delBtn{
        text-align: right;
        .ant-btn{
            height: 24px;
            line-height: 24px;
            border-radius: 2px;
            text-align: center;
            font-size: 14px;
        }
    }
</style>